import { Button, Modal, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import PopUp from '../pages/pharmacists/ViewProfile/PopUp/PopUp';
import { LoadingOutlined } from '@ant-design/icons';
import ImageWithSkeleton from './ImageWithSkeleton';

function CardCurrentPrescription({ data, userId, idPrescription, ConditionName, setFlagFetch }) {
    const { medicineDetails } = data;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    const handleTabChange = (key) => {
        setIsModalVisible(true);
    };

    // Set loading state to false after the image is loaded
    const handleImageLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        if (data.prescriptionImage) {
            setLoading(false);

        }
    }, [isModalOpen]);
    return (
        <>
            <PopUp visible={isModalVisible} onClose={handleCloseModal} data={data} patch={"patch"} UserID={userId} idPrescription={idPrescription} ConditionName={ConditionName} setFlagFetch={setFlagFetch} />
            <div className='my-10 space-y-5 border p-5 border-[#E0EAFC]'>
                <div className='flex space-x-5 w-full'>
                    <div className='w-[81px] h-[81px] '>
                        <ImageWithSkeleton
                            noRounded={true}
                            src={medicineDetails?.image || 'https://s3.us-east-2.amazonaws.com/followvita.com/src/47dd4265-9e57-479a-adc7-b8acab1489c6_Rectangle%202757.png'}
                            alt="Medicine"
                            className="w-[100%] h-[100%]"
                            classNameInIMage="w-[100%] h-[100%] object-cover"
                        />
                    </div>

                    <div className='flex flex-col w-[90%] justify-around'>
                        <div className='flex justify-between'>
                            <p style={{ fontSize: "24px", fontWeight: "600", }}>{medicineDetails?.name}</p>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>{dayjs(data.endDate).format('DD/MM/YYYY')}</p>
                        </div>
                        <div className='flex flex-row justify-between'>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>Dose: {data.medicineDetails.dose}</p>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>Timing: {data.timeToTake}</p>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>Number of pills per dose: {data.amountOfDose}</p>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col space-y-3'>
                    <p style={{ fontSize: "14px", fontWeight: "500", }}>Comment:</p>
                    <div className='bg-[#F9FBFF] p-3 rounded-lg'>
                        <p style={{ fontSize: "14px", fontWeight: "400", }}>{data.comments ? data.comments : "No Comment Yet"}</p>
                    </div>
                </div>
                <div className='flex items-center space-x-5'>
                    <Button onClick={handleTabChange} style={{ padding: "20px", color: "#A9A9A9", fontSize: "12px", fontWeight: "400" }} icon={<img src='/assets/images/edit-2.svg' alt="edit-icon" style={{ width: '16px' }} />} >
                        Edit prescription
                    </Button>
                    {data.prescriptionImage ?
                        <Button
                            style={{ color: "#3371EB", borderColor: "#3371EB", padding: "20px", fontSize: "12px", fontWeight: "400" }}
                            onClick={() => setIsModalOpen(true)}
                        >
                            View Attachments
                        </Button>
                        : null}
                </div>
            </div>
            <Modal
                title="Prescription Attachment"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={600}
            >
                {loading ? (
                    <Spin indicator={<LoadingOutlined spin />} />
                ) : data.prescriptionImage ? (
                    <img
                        src={data.prescriptionImage}
                        alt="Prescription"
                        style={{ width: "100%", borderRadius: "8px" }}
                        onLoad={handleImageLoad} // Trigger loading state to false after the image is loaded
                    />
                ) : (
                    <p>No attachment available</p>
                )}
            </Modal>
        </>
    );
}

export default CardCurrentPrescription;
